import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        //案例
        caseAll:[
            {
                Content: `质谱是通过检测气相离子的质荷比（m/z）来鉴定化合物的一种分析仪器，可在一次分析中提供丰富的物质结构信息，是一种同时具备高特异性和高灵敏度的仪器，由于质谱技术复杂、难度高，被誉为科学仪器产业皇冠上的明珠。我们的毒检仪为新型质谱仪器，结合了激光技术与质谱技术，检测速度快，可对样品的检测位置准确定位，并获得高分辨、高灵敏度的质谱图。
        
            此质谱毒检仪的主要优势包括：
        1）超高的检测效率：与传统检测仪器（如液相色谱-质谱联用等）相比，新型质谱仪只需要微量的生物检材（如一根毛发、血斑、尿斑等），并且几乎不需前处理，即可对血液、尿液、唾液及毛发等生物检材进行高准确度的检测；检测成本低、耗时短（仅需一分钟左右）；兼备传统实验室仪器和快检设备的优点，在成本和效率上，都实现了全面超越，是目前仅有的可实现快筛与鉴定一体化的设备。
        2）毒品分布检测与吸毒史揭示：传统检测仪器（如液相色谱-质谱联用等）无法检测吸毒次数；新型质谱仪可检测头发或指甲上不同位置的毒品分布，进而可推测出被检人的吸毒次数与吸毒史；
        3）新型毒品检测：传统检测仪器（液质等）是对已知物的针对性检测，对标准品依赖较强，只能检测出有对应标品的已知物；新型质谱仪检测不依赖于标品，可覆盖几乎全部传统毒品以及新型毒品；结合禁毒赋能系统，可实现新型毒品的智能预警与溯源。
        4）全谱检测：可全面检测所有人体摄入物质，包括兴奋剂、治疗药品等；具有广泛的潜在用途。\n \t\t\t\t\t\t\t\t\t\t\t————厦门历思生物科技有限公司
                `,
                CreateTime: "2020-06-05",
                Del: null,
                Id: 1,
                Img: "ZP.png",
                Title: "质谱毒检仪——厦门历思生物",
            },
            {
                Content:`在“污水验毒”等工作中，数据的真实性和客观性关系到对毒情的真实掌握；也关系到未来对地方禁毒工作的评价，过程一旦出现疏漏，就可能造成对基层积极性的挫伤。检验鉴定的取样环节是确保真实、客观还原事实的源点，因此取样应做到标准科学、程序严密、全程受控。
            本设备采用了创新的进样器、水样分配器设计，实现了样品于-20℃环境的保存与进样。结合了传感器技术，物联网技术，大大提高了设备的稳定性、进样的灵活性，并加入了样品安全保护功能，极大的降低样品被替换、破坏的风险。
        
            此采样器的主要优势包括：
        1）真正的超低温进样能力与丰富的进样方式：与传统采样器相比，本采样器通过特殊的进样器设计，可以实现样品在-20℃环境保存时，仍可正常进样，满足了部分采样标准中对样品保存温度的要求；本采样器使用创新的进样系统，配合优化的进样逻辑，可以实现灵活多样的进样方式。
        2）样品更安全，采样更规范：采用授权电控锁保护样品安全，结合摄像头与网络加密、授权技术，实现样品取样安全可控、可追溯；加入保存区异常开盖传感器，实现异常开启报警功能；取样瓶唯一性设计和图形化编码，实现可溯源管理并可有效防止样品被提前打开；创新地加入了多种传感器，可以监控设备进样压力、样品切换器工作状态、保存区影像、保存区冰箱温度、环境温度、大气压力、位置坐标、采样水体流量（选装）等信息，结合缜密的保护逻辑，可以对样品的保存情况、设备的工作状况进行可控管理，极大地提高了设备运行稳定性
        3）远程控制与物联网化数据管理：采样器及其配套软件结合物联网技术实现了设备与后台服务器的连结；设备的运行状况，设备采样的各种参数数据等均可上传至服务器。设备运行的模式，参数也可以通过服务器下发至采样器。系统还可通过集群控制，一次性控制多台设备；专用终端软件使用户可以通过手机方便地进行监控、设置\n \t\t\t\t\t\t\t\t\t\t\t————厦门历思生物科技有限公司
        `,
                CreateTime: "2020-06-05",
                Del: null,
                Id: 2,
                Img: "SZ.png",
                Title: "智慧水质采样器——厦门历思生物",
            },
            {
                Content:`远程交接物证箱，简称物证箱，可以实现检材或证物的安全、可信和整句话交接，充分降低物流与交接过程风险。使用物证箱不但可防止检材或政务在流转过程中被破坏或调换，未来还可用于其它高价值物品的安全交接。物证箱的主要功能包括：
        1.	箱体抗破坏机制
        2.	内置气压、振动、温度防破坏检测告警装置
        3.	箱外全方位交叉监测装置
        4.	箱内检材状态监测装置
        5.	特殊电池仓设计保护检材安全
        6.	检材射线屏蔽装置，防止外部对检材进行无损探测
        7.	电池备份设计、特别的电池寿命检测系统
        8.	远程授权认证启闭系统（通过委托方以及被委托方等共同授权）
        9.	故障、低电量自检装置
        基于以上功能，如果出现外力撞击、敲打等非正常方式开箱，系统会自动预警；如果物证远程交接箱的运输轨迹偏离预定路径时，系统会自动预警；以此来保证物证远程交接箱中检材的安全性。
        \n \t\t\t\t\t\t\t\t\t\t\t————厦门历思生物科技有限公司
        `,
                CreateTime: "2020-06-05",
                Del: null,
                Id: 3,
                Img: "WZX.png",
                Title: "物证箱——厦门历思生物",
            },
        ],
        //荣誉
        honoralAll:[
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "honoral1.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            }
        ],
        // 团队
        teamAll:[
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "team1.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            },
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "team2.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            },
        ],
        // 合作伙伴
        partnerAll:[
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "partner1.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            },
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "partner2.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            },
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "partner3.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            },
            {
                CreateTime: "2021-03-26",
                Id: 31,
                Img: "partner4.jpg",
                Remark: "集成研究、检测、鉴定、培训、认证、咨询能力————厦门历思生物科技有限公司"
            },
        ],
        // 新闻资讯--公司
        newsCompany:[
            {
                Content: `近日，《福建省污染地块调查评估、治理修复单位专业机构推荐名录（2021年度）》已经发布。

        历思物证科技产研体系成员企业——厦门堃晟检测技术有限公司（以下简称“堃晟”）成功入选调查评估类、方案编制类、效果评估类等类目推荐机构。
                                                                                                    \n \t\t\t\t\t\t\t\t\t\t\t————厦门历思生物科技有限公司`,
                CreateTime: "2021-03-25",
                Id: 1,
                Img: [
                    "new1-1.png",
                    "new1-2.png",
                    "new1-3.png",

                ],
                Title: "堃晟入选福建省污染地块调查评估、治理修复单位专业机构推荐名录",
                Type: 1,
            },
            {
                Content: `热烈祝贺厦门历思科技服务有限公司（以下简称“历思”）通过了“国家高新技术企业”认定，由此正式迈入国家高新技术企业行列。
        秉持“智慧物证，可信鉴定”的理念，历思长期致力于发展智慧物证科技，为社会提供可信鉴定服务。立足原发性创新，通过综合服务与配套软硬件产品的结合，历思在物证与鉴定领域建立了独特的竞争优势。
        今后，整个历思科技产研体系将持续创新，推动IT、刑侦等当代科技在物证与鉴定领域的融合、创新，以此获得竞争力与发展机遇。
                                                                                                        \n \t\t\t\t\t\t\t\t\t\t\t————厦门历思生物科技有限公司`,
                CreateTime: "2021-03-25",
                Id: 2,
                Img: [
                    "new2-1.jpg",
                    "new2-2.jpg",

                ],
                Title: "喜讯！热烈祝贺历思科技通过高新技术企业认定！",
                Type: 1,
            },
            // {
            //     Content: "近日，浙江省禁毒总队、福建省禁毒总队领导一行 莅临福建历思司法鉴定所（以下简称“历思”）考察交流城市污水监测、毒情监测预警体系建设等工作。浙江省禁毒总队、福建省禁毒总队领导一行参观了历思物证中心实验室， 对 “单根毛发验毒” 和 “实时在线污水采集” 技术的新设备、新平台产生了浓厚 的兴趣，并观看了 “智慧禁毒物联网” 以及由禁毒办指导研发的 “国产新型质谱毒检仪” 、 “智慧水质采样器 的演示，高度评价了历思在禁毒装备创新和禁毒科技应用等方面取得的突出成果。\n \t在座谈会上，双方就 城市污水监测、毒情监测预警体系建设 以及 毛发毒检 等方面进行深入的沟通交流。浙江省禁毒总队、福建省禁毒总队领导一行表示， 禁毒工作离不开科技助力，历思的科技创新成果应积极推广，更好地应用于禁毒一线，与禁毒部门形成合力，共同打击各类毒品犯罪活动。\n \t\t\t\t\t\t\t\t\t\t\t————厦门堃铭生物科技有限公司",
            //     CreateTime: "2020-12-03",
            //     Id: 3,
            //     Img: [
            //         "new3-1.jpg",
            //         "new3-2.jpg",
            //         "new3-3.jpg",
            //     ],
            //     Title: "浙江省禁毒总队、福建省禁毒总队领导一行莅临历思就“污水验毒”等技术进行考察交流！",
            //     Type: 1,
            // },
            {
                Content: `案件详情：
            2019年1月18日，陈某因发热、寒战、双下肢疼痛被送至医院。医院诊断为L5椎体感染性脊柱炎，并对陈某进行抗感染治疗。
            2月12日复查胸部+腰椎CT显示：双肺炎症较前明显好转，L5椎体内低密度灶较前无著变，经医患沟通后于2月13日转脊柱外科进一步治疗。
            2019年2月16日，医院对陈某进行腰椎后路脓肿病灶清除对冲灌洗引流术，术后陈某入院症状缓解。
            2月27日18时陈某出现腹痛、全身大汗淋漓，心率加快等病情变化。经治疗陈某血压、心率等恢复正常。23时陈某病情再次急剧恶化，休克加重，经多学科会诊积极抢救后效果不佳。
            2019年2月28日，陈某经抢救无效死亡，最后诊断死亡原因为呼吸循环衰竭及感染性休克。
            
            家属起诉医院 
            陈某家属认为医院在陈某入院20多天后才确诊病因，延误病情，存在误诊；且在陈某死亡时未依法告知家属应进行尸检以明确死因，应对陈某死亡结果承担主要责任，遂诉至法院，要求医院一次性赔偿医疗费、护理费、交通费、住院伙食费、丧葬费、死亡赔偿金、鉴定费、精神损害抚慰金等共计676715元。
            诉前，经陈某家属申请，法院进行两次委托鉴定，两鉴定机构均以陈某死后未进行尸体解剖及病理学检验，无确切的死亡原因为由出具《不予受理通知书》。\n \t 法院审理认为：本案中，针对原告提出的被告存在误诊误治、延误治疗等过错的问题，被告进行了合理的解释，被告的诊疗行为并无明显的过错。鉴于医疗行为的极度专业性，如需进一步确定被告是否存在医疗过错，需要进行司法鉴定。对于未做尸检的原因，被告医院称患者死亡当天就已经向患者家属出具了《死亡医学证明书》，患者家属并未对死亡原因提出异议，双方亦未发生纠纷，因此并未告知患者家属关于尸检的相关情况。根据卫生部颁布的《医疗机构管理条例实施细则》第六十条的规定，《死亡医学证明书》只是对患者死亡的医学临床诊断，在死因被作为关键问题进行审查时，《死亡医学证明书》不能作为判断死者死因的诊断。如果要进一步明确死因，需要通过尸体解剖等检查。本案中，被告医院熟知临床死亡原因和病理死亡原因的区别，熟知进行尸检以确定病理死亡原因的必要性和重要性；但作为不具备医疗专业知识的患者家属，因为信息不对称及专业医疗认知水平的限制，不知晓被告医院出具的《死亡医学证明书》仅能作为患者是否死亡的诊断，不能作为死亡原因的诊断，亦不知晓如果要进一步明确死因需要通过尸检等检查，由此患者家属未进行尸检，最终导致司法鉴定机构无法确定被告医院的医疗行为是否存在过错。故此，在医患双方因为患者死亡原因发生争议时，被告医院疏于告知尸检的行为存在一定的过错，但该过错又并非导致患者死亡的原因，考虑到陈某的病情病史，结合本案实际情况，法院酌情确定被告医院对陈某的死亡给原告所造成的损害承担30％的责任。
                                                                                                    \n \t\t\t\t\t\t\t\t\t\t\t————厦门历思生物科技有限公司`,
                CreateTime: "2020-12-03",
                Id: 4,
                Img: [
                    "new4-1.gif",
                ],
                Title: "《死亡医学证明书》能作为认定患者死因的依据吗？",
                Type: 2,
            },
        ]
    }
})